import { useContext } from "react";
import { PayActionContext } from "./PayActionContext";

function usePreparePay() {
  const { setElementId, setShowModal } = useContext(PayActionContext);
  return (id: any) => {
    setElementId(id);
    setShowModal(true);
  };
}

export default usePreparePay;
